
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div className='ui stackable grid receipe'>
  <div className='ui sixteen wide column c'>
    Hafer-Porridge mit Himbeeren und Sonnenblumenkernen
  </div>
  <div className='ui six wide column a'>4 EL feine Haferflocken</div>
  <div className='ui ten wide column b'>mit</div>
  <div className='ui six wide column a'>100 ml heissem Wasser</div>
  <div className='ui ten wide column b'>übergiessen.</div>
  <div className='ui six wide column a'>2–3 Datteln</div>
  <div className='ui ten wide column b'>
    waschen, halbieren, entkernen, klein schneiden und mit der Hälfte von
  </div>
  <div className='ui six wide column a'>150 g gemischten Beeren</div>
  <div className='ui ten wide column b'>
    (Blaubeeren, Himbeeren etc.) pürieren.
  </div>
  <div className='ui six wide column a'>1 EL Sonnenblumenkerne</div>
  <div className='ui ten wide column b'>rösten.</div>
  <div className='ui six wide column a' />
  <div className='ui ten wide column b'>
    Eingeweichte Haferflocken mit Beerenpüree verrühren und mit den restlichen
    Beeren und Sonnenblumenkernen anrichten
  </div>
    </div>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;